const isMobile = (ua: string) =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

// Mobile device detection
export const isMobileUserAgent = (): boolean => {
  const { userAgent = '' } = navigator;

  return isMobile(userAgent);
};
